import type { FilterType, State } from '../../typings'

export function toggleFilterByNameReducer(
  state: State,
  payload: string,
): State {
  const newState: State = { ...state }
  const checkSum = 0

  if (isNaN(payload as any)) {
    // Status Updates & Closing Activities
    const categoryAndName = payload.split('|')
    if (categoryAndName.length === 2) {
      const category: FilterType = categoryAndName[0] as FilterType
      const name = categoryAndName[1]
      switch (category) {
        case 'statusUpdates': {
          newState.filters.statusUpdates.filters.forEach((x) => {
            if (x.name === name) {
              x.isSelected = !x.isSelected
            }
          })
          break
        }
        case 'closingActivities': {
          newState.filters.closingActivities.filters.forEach((x) => {
            if (x.name === name) {
              x.isSelected = !x.isSelected
            }
          })
          break
        }
      }
    }
  } else {
    // Custom Activities
    newState.filters.customActivities.filters.forEach((x) => {
      if (x.id === +payload) {
        x.isSelected = !x.isSelected
      }
    })
  }

  return { ...newState, filtersChecksum: checkSum }
}
